import React, { Component } from 'react';
import { Button } from '@blueprintjs/core';
import EasyTable from '../../EasyTable';
import EditableDetail from '../EditableDetail';
import FileDropzoneContainer from '../../../../containers/projectmanager/FileDropzoneContainer';
import PMAssignmentSection from '../PMAssignmentSection';
import EditableAdditionalDetail from '../EditableAdditionalDetail';
import InputText from '../../../blueprintWrappers/InputText';

class PMProject extends Component {

	render() {
		const p = this.props;
		return (
			<div className={"PMProject page"}>

				<div className={"topheader"}>
					<div className={"topheader_left"}>

					</div>
					<div className={"topheader_right"}>

					</div>
				</div>

				<div className="content">
					<div className="content_center">
						<div className={"content_header"}>

							<div className={"content_header_helper"}>
								<div onClick={p.goBack}><span className="icon">&#x25C0;</span>{"Back"}</div>
							</div>
						</div>

						<div className={"content_panel"}>
							{this.notifications()}
							{this.details()}
							{this.additionalDetails()}
							{p.reduxData.currentUserRole == 'Admin' ? this.invoicing() : null/* TODO1 follow up when roles are implemented */}
						</div>

						<div className={"content_panel"}>
							{this.phases()}
						</div>
						<div className={"content_panel"}>
							{this.assigned()}
						</div>
						<div className={"content_panel"}>
							{this.attachments()}
						</div>
					</div>
				</div>

			</div>
		);
	}

	notifications = () => {
		const p = this.props;
		const { saved } = p.state;

		return <div>
			{saved ?
				null
				:
				<div style={{ backgroundColor: 'red' }}>
					This Project has unsaved details
					<Button onClick={p.toggleSaved}>
						Save
				</Button>
				</div>
			}
		</div>
	}

	details = () => {
		const p = this.props;
		const { currentItem } = p.state;

		return (
			<div className={"PMProjectDetails"}>
				<EditableDetail
					property={"display"}
					value={currentItem.display}
					onChange={p.onChange}
					onSave={p.onChange}
				/>
				<EditableDetail
					small
					property={"description"}
					value={currentItem.description}
					onChange={p.onChange}
					onSave={p.onChange}
				/>
			</div>
		)
	}

	additionalDetails = () => {
		const p = this.props;
		const { newCommentLine } = p.state;
		const { storedCommentLines } = p.reduxData;

		if (storedCommentLines.length === 0) {
			return (
				<div className={"AdditionalDetails"}>

					<InputText
						onChange={p.onChangeAdditionalDetail}
						value={newCommentLine.comment}
						returnObj={{ attr: "comment" }}
						placeholder={"Add a new detail"}
					/>

					<Button onClick={() => p.addAdditionalDetail()} >
						+ Add Additional Detail
					</Button>
				</div>
			)
		}

		return (
			<div className={"AdditionalDetails"}>
				{storedCommentLines.map((detail, index) => {
					return <EditableAdditionalDetail
						small
						value={detail}
						index={index}
						key={detail.uniqueID + '_editable_' + index}
						updateComment={p.updateComment}
					/>
				})}

				<InputText
					onChange={p.onChangeAdditionalDetail}
					value={newCommentLine.comment}
					returnObj={{ attr: "comment" }}
					placeholder={"Add a new detail"}
				/>
				<Button onClick={() => p.addAdditionalDetail()} >
					+ Add Additional Detail
				</Button>

			</div>
		)
	}

	invoicing = () => {
		const p = this.props;
		const { currentItem } = p.state;
		const { currentInvoice } = p.reduxData;

		return <div>
			{currentItem.invoiceEntry && currentInvoice ?
				<div style={{ backgroundColor: 'green' }}>
					This Project is invoiced. TODO more details and status.
					{currentInvoice.invoiceEntry +' - '}
					{'$' + currentInvoice.docTotal}
					{'$' +currentInvoice.paidToDate}
				</div>
				:
				<div>
					<div style={{ backgroundColor: 'red' }}>
						This Project has not been invoiced
						
					</div>
					<EditableDetail
							property={"invoiceEntry"}
							value={currentItem.invoiceEntry}
							onChange={p.onChange}
							onSave={p.onChange}
						/>
				</div>
			}
		</div>
	}

	phases = () => {
		const p = this.props;
		const { filteredPhases } = p.state;

		return (
			<div className={"PMProjectPhases"}>
				<EasyTable
					tableName={"Project Phases"}
					selectValue={'uniqueID'}
					headers={['Phase', 'BP', 'Project', 'Project Staff', 'Status']}
					show={['display', 'bp', 'project', 'assigned', 'status']}
					data={filteredPhases}
					onClick={p.selectPhase}
					customColumns={['assigned']}
					renderCustomColumn={this.renderCustomColumn}
				>
					<Button onClick={p.addPhase} >
						+ Add New Project Phase
					</Button>
				</EasyTable>
			</div>
		)
	}

	renderCustomColumn = (property, row, i) => {
		switch (property) {
			case 'assigned':
				let usernames = [];
				row[property].forEach(element => {
					let loc = this.props.reduxData.storedUsers.findIndex(indexOfUser)

					if (loc > -1) {
						usernames.push(this.props.reduxData.storedUsers[loc].firstName + ' ' + this.props.reduxData.storedUsers[loc].lastName.substring(0, 1))
					}

					function indexOfUser(usr) {
						return usr.uniqueID === element;
					}
				});
				return <td key={i}>{usernames.join(", ")}</td>
			default:
				return <td key={i}>{row[property]}</td>
		}
	}

	assigned = () => {
		const p = this.props;
		const { assignedUsers } = p.state;
		return (
			<div className={"PMProjectAssigned"}>
				<PMAssignmentSection
					users={assignedUsers}
					header={"Assigned Internal Users:"}
					addAssigned={p.addAssigned}
					removeAssigned={p.removeAssigned}
				/>
			</div>
		)
	}

	attachments = () => {
		const p = this.props;
		return (
			<div className={"PMProjectAttachments"}>
				<h3>Attachments</h3>
				<FileDropzoneContainer />
			</div>
		)
	}
}

export default PMProject;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/Project/PMProject.js